import Stars from './Stars';

export default Stars;
